import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		config: {},
		update: null,
		UpdateTIme: null,
		loading: false,
		loadingTimes: null,
		dialogDefault: false,
		dialogRestoreFactory: false,
		equipmentStatus: false,
		equipmentShowStatus: false,
		NOTLINKEDSTATUS: false,
		pdfPages: [],
		Upgrade: {
			progress: 0,
			status: false,
			dialogStatus: false,
			pause: false,
			type: 0
		},
		dtsData: {
			status: false,
			dialogStatus: false,
		},
	},
	getters: {
		config: (state) => state.config,
	},
	mutations: {
		gotState(state, payload) {
			state[payload.key] = payload.data;
		},
		setLoading(state, payload) {
			// console.log(payload)
			state.loading = payload;
		},
		setUpgrade(state, payload) {
			let Upgrade = state.Upgrade;
			for(let i in payload) {
				Upgrade[i] = payload[i]
			}
			state.Upgrade = Upgrade;
			localStorage.setItem('setUpgrade', JSON.stringify(Upgrade))
		},
		open(state, payload) {
			window.open(payload)
		}
	},
	actions: {
		getConfig({ commit, dispatch }, payload) {
			let config = localStorage.getItem('config');
			config = config ? JSON.parse(config) : {};
			commit("gotState", { key: "config", data: config });
		},
		setConfig({ commit, dispatch }, payload) {
			commit("gotState", { key: "config", data: payload });
			localStorage.setItem('config', JSON.stringify(payload));
		}
	},
	modules: {}
})